module.exports = __webpack_public_path__ + "static/media/Rectangle 7.f8a68594.png";